import { nfcCardConfigurationGroupsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("card-reader-preset"),
  endpoint: "nfc-card-configuration-groups",
  operations: nfcCardConfigurationGroupsOps,
  roleView: [ROLE.CONTAINER_VIEW, ROLE.CONTAINER_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN],
  dependencies: ["container"],
  singularName: (t) => t("Card reader preset"),
  name: (t) => t("Card reader presets"),
  syncCustomerFilter: true,
});

export default conf;
